import React from "react";
import './Intro.css'
import Github from '../../img/github__1.png';
import Instagram from '../../img/instagram__1.png';
import Linkedin from '../../img/linkedin__1.png';
import Woman_Sitting from '../../img/Woman_Sitting.png';
import thumbup from '../../img/thumbup.png';
import crown from '../../img/crown.png';
// import glassesimoji from '../../img/glassesimoji.png';
import FloatingDiv from "../FloatingDiv/FloatingDiv";
import {motion} from 'framer-motion'
import { useContext } from "react";
import { themeContext } from "../../Context";
const Intro = () =>{

  const transition = {duration : 2, type: 'spring'}

  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return(
  
    <div className="Intro">
        <div className="i-left">
            <div className="i-name">
                <span class="H" style={{color: darkMode? 'white': ''}}> H </span>
                <span class="i" style={{color: darkMode? 'white': ''}}> i!</span>
                <span class="I" style={{color: darkMode? 'white': ''}}> I </span>
                <span class="Am" style={{color: darkMode?' white': ''}}>Am</span>

                <span> Faizan Saifi</span>
                <span> Frontent Developer with high
                    level of Experience in with desiging
                    and Developer,<br/>
                    Production the Quality work</span>
            </div>            

            <button className="button i-button">Hire me</button>
           <div className="i-icons" > 
           
             <img src={Github} alt=""/>
             <img src={Instagram} alt=""/>
             <img src={Linkedin} alt=""/>   
           </div>


        </div>
        <div className="i-right">
           <img src ={Woman_Sitting} alt=""/>

         {/*Emoji Motion */}
           <motion.img 
           initial={{left: '-36%'}}
           whileInView ={{left: '-24%'}}
           transition={transition}
           src ="" alt=""/>

{/* Motion.div (div in motion) <motion.div> ------ </motion.div>*/}
           <motion.div
           initial={{top: '-4%', left: '74%'}}
           whileInView={{left: '68%'}}
           transition={transition}

           style={{top:'-4%', left:'68%'}}
           className='floating-div'
           >

          <FloatingDiv image={crown} txt1='web' txt2='Developer'/>
           </motion.div>

           <motion.div 
           initial={{left: '9rem', top: '18rem'}}
           whileInView={{left: '0rem'}}
           transition={transition}
           
           style={{top:'16rem', left:'-3rem'}}
           className='floating-div'
           >
            
           <FloatingDiv image={thumbup}  txt1='Best Design' txt2={'Award'}/>
           </motion.div>     

           {/* blur div */}
           <div className="blur" style={{background: "rgb(236 210 255)"}}>
           </div>

          <div className="blur" style={{
            background: '#C1F5FF',
            top: '17rem',
            width: '21rem',
            height: '11rem',
            left:'-9rem'
          }}>

          </div>           
        </div>
    </div>
  )
};
 
export default Intro;